import Users from "./Users.vue";
import UsersView from "./UsersView.vue";

const UsersRoutes = [
  {path: '/users', components: {default: Users},},
  {path: '/users/users', name: "Users", components: {default: Users},},
  {path: '/users/users/:id', name: "UserView", components: {default: UsersView},},
];
export default UsersRoutes;
